module.exports = __webpack_public_path__ + "img/sup_deposit_crypto7.974e3bd1.jpg";